import { createSlice } from "@reduxjs/toolkit";
import {
  fetchFirebaseToken,
  fetchGlobalAlertsData,
  dismissAllAlertsData
} from "./GlobalAlertsAsyncThunks";
import {
  handleFailFetchGlobalAlertsData,
  handleFulfillDismissAllAlerts,
  handleFulFillFetchFirebaseToken,
  handleFulfillFetchGlobalAlertsData,
  handleFailDismissAllAlerts,
  handlePendingDismissAllAlerts,
  handlePendingFetchFirebaseToken,
  handlePendingFetchGlobalAlertsData,
  initialState,
  handleResetAlerts
} from "./GlobalAlertsReducers";

const globalAlertsSlice = createSlice({
  name: "userDetail",
  initialState,
  reducers: {
    handleResetAlerts
  },
  extraReducers(builder) {
    builder
      .addCase(
        fetchGlobalAlertsData.pending,
        handlePendingFetchGlobalAlertsData
      )
      .addCase(
        fetchGlobalAlertsData.fulfilled,
        handleFulfillFetchGlobalAlertsData
      )
      .addCase(fetchGlobalAlertsData.rejected, handleFailFetchGlobalAlertsData)
      .addCase(fetchFirebaseToken.fulfilled, handleFulFillFetchFirebaseToken)
      .addCase(fetchFirebaseToken.pending, handlePendingFetchFirebaseToken)
      .addCase(dismissAllAlertsData.pending, handlePendingDismissAllAlerts)
      .addCase(dismissAllAlertsData.fulfilled, handleFulfillDismissAllAlerts)
      .addCase(dismissAllAlertsData.rejected, handleFailDismissAllAlerts);
  }
});
export const { handleResetAlerts: resetGlobalAlerts } =
  globalAlertsSlice.actions;

export default globalAlertsSlice.reducer;
